<template>
  <div>
    <b-input-group>
      <b-form-datepicker
          class="range-date-picker"
          label-no-date-selected=""
          v-model="firstDatePicker"
          :button-only=false
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
          :date-disabled-fn="dateDisabled"
          size="sm"
          locale="en-UK">
      </b-form-datepicker>
      <div class="dp-separator">-</div>
      <b-form-datepicker
          class="range-date-picker"
          v-model="secondDatePicker"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
          size="sm"
          :button-only=false
          label-no-date-selected=""
          :date-disabled-fn="dateDisabled"
          locale="en-UK">
      </b-form-datepicker>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'TwoRangeDatePickers',
  props: ['value', 'options'],
  data()
  {
    return {
      firstDatePicker: null,
      secondDatePicker: null
    }
  },
  mounted()
  {
    this.setPredefinedValue(this.value)
  },
  watch: {
    value(val) {
     this.setPredefinedValue(val)
    },
    firstDatePicker(val)
    {
      this.setPicker(val)
    },
    secondDatePicker(val)
    {
      this.setPicker(val)
    }
  },
  methods: {
    dateDisabled(ymd, date)
    {
      const now = new Date()
      const selectedDate = date.getTime()
      return now.getTime() < selectedDate
    },
    setPicker(val)
    {
      // console.log(val)
      // console.log('Catch setPicker')
      if (val)
      {
        this.$emit('updatevalues', [this.firstDatePicker, this.secondDatePicker])
      }
    },
    setPredefinedValue(val)
    {
      if (val && Array.isArray(val)) {
        this.firstDatePicker = val[0]
        this.secondDatePicker = val[1]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.range-date-picker {
  max-width: 145px;
  margin-right: 10px;
  font-size: 12px;
}
</style>
